module.exports = __webpack_public_path__ + "static/img/v12.7557520.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v12.jpg
// module id = x/l2
// module chunks = 1